/* Presentation-only mobile gallery; does not touch purchasing or variant state. */
(() => {
  if (window.fbRetailGalleryBound) return;
  window.fbRetailGalleryBound = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-fb-gallery-src]');
    if (!button) return;
    const gallery = button.closest('.fb-retail-mobile-gallery');
    if (!gallery) return;
    const image = gallery.querySelector('.fb-retail-mobile-gallery__main');
    image.removeAttribute('srcset');
    image.src = button.dataset.fbGallerySrc;
    image.alt = button.dataset.fbGalleryAlt;
    gallery.querySelectorAll('[data-fb-gallery-src]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
  });
})();
